// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.summary-popup {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.summary-popup-header {
  padding: 24px 24px 16px 24px;
}

.summary-popup-header h2 {
  font-size: 20px;
  font-weight: 500;
  color: #111827;
  margin: 0;
}

.select-text {
  color: #0d9488;
  font-weight: normal;
}

.summary-type-selector {
  padding: 24px;
}

.buttons-container{
  width: max-content;
  border-radius: 8px;
  gap: 12px;
  background-color: #F4F4F5;
}

.type-button {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background-color: #f3f4f6;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.type-button:hover {
  background-color: #e5e7eb;
}

.type-button.active {
  background-color: white;
  color: #0d9488;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.summary-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 24px 24px 24px;
}

.summary-content section {
  margin-bottom: 24px;
}

.summary-content h3 {
  font-size: 16px;
  font-weight: 500;
  color: #111827;
  margin: 0 0 12px 0;
}

.summary-content p {
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  margin: 0 0 8px 0;
}

.summary-popup-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}

.confirm-button {
  padding: 10px 20px;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.confirm-button:hover {
  background-color: #0f766e;
}

/* Scrollbar styling */
.summary-content::-webkit-scrollbar {
  width: 6px;
}

.summary-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.summary-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.summary-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.transcript-processing {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.processing-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #111827;
  margin: 0 0 0.5rem 0;
}

.processing-subtitle {
  font-size: 1rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
  max-width: 400px;
}

.start-session-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.start-session-button:hover {
  background-color: #0f766e;
}

.button-icon {
  width: 1.25rem;
  height: 1.25rem;
}


`, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/SummaryPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,uEAAuE;AACzE;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".summary-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.summary-popup {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.summary-popup-header {\n  padding: 24px 24px 16px 24px;\n}\n\n.summary-popup-header h2 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #111827;\n  margin: 0;\n}\n\n.select-text {\n  color: #0d9488;\n  font-weight: normal;\n}\n\n.summary-type-selector {\n  padding: 24px;\n}\n\n.buttons-container{\n  width: max-content;\n  border-radius: 8px;\n  gap: 12px;\n  background-color: #F4F4F5;\n}\n\n.type-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 8px;\n  background-color: #f3f4f6;\n  color: #6b7280;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.type-button:hover {\n  background-color: #e5e7eb;\n}\n\n.type-button.active {\n  background-color: white;\n  color: #0d9488;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.summary-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 24px 24px 24px;\n}\n\n.summary-content section {\n  margin-bottom: 24px;\n}\n\n.summary-content h3 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #111827;\n  margin: 0 0 12px 0;\n}\n\n.summary-content p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #374151;\n  margin: 0 0 8px 0;\n}\n\n.summary-popup-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.confirm-button {\n  padding: 10px 20px;\n  background-color: #0d9488;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.confirm-button:hover {\n  background-color: #0f766e;\n}\n\n/* Scrollbar styling */\n.summary-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.summary-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.summary-content::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n}\n\n.summary-content::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n.transcript-processing {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.processing-title {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #111827;\n  margin: 0 0 0.5rem 0;\n}\n\n.processing-subtitle {\n  font-size: 1rem;\n  color: #6b7280;\n  margin: 0 0 1.5rem 0;\n  max-width: 400px;\n}\n\n.start-session-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: #0d9488;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.start-session-button:hover {\n  background-color: #0f766e;\n}\n\n.button-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
